export default __webpack_public_path__ + "login_bg.a681bfe.jpg";